<template>
  <div>
    <page-main :tableData="tableData" :loading="loading" @reload="getData">
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @openChooseFabricColor="onOpenChooseFabricColor"
      />
    </page-main>
    <FabricColorTable
      v-if="addFabricVisible"
      :visible.sync="addFabricVisible"
      :proofingCode="proofingCode"
      @saveBatch="saveBatch"
    ></FabricColorTable>
  </div>
</template>
<script>
import FabricColorTable from './components/fabric-color-table'
import PageHeader from './header'
import PageMain from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { PageMain, PageHeader, FabricColorTable },
  props: {
    proofingCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      usePage: false,
      addFabricVisible: false,
      tableData: [],
      loading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onOpenChooseFabricColor() {
      this.addFabricVisible = true
    },
    getData() {
      this.loading = true
      this.$api
        .customerProofingFabricListApi({
          proofingCode: this.proofingCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res?.body?.data || []
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'customerManage-selectionTracking-detail',
        params: { ...params, pageType },
      })
    },
    saveBatch(fabricData) {
      this.loadingOpen()
      this.$api
        .customerProofingFabricBatchSaveApi({
          proofingCode: this.proofingCode,
          saves: fabricData,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.reloadFabricInfo()
          this.addFabricVisible = false
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    reloadFabricInfo() {
      this.getData()
    },
  },
}
</script>
